import { render, staticRenderFns } from "./ViewSolicitudHistorica.html?vue&type=template&id=7fcf2752&external"
import script from "./ViewSolicitudHistorica.vue?vue&type=script&lang=js"
export * from "./ViewSolicitudHistorica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports